import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HopeRecoveryHome from "@/pages/HopeRecoveryHome";
import FlyerPage from "@/pages/FlyerPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HopeRecoveryHome />} />
                <Route path="/flyer" element={<FlyerPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
